<template>
  <filtertron-tray-section
    id="category-configurator-general"
    :title="lang.get('category.configuration.general.label')"
  >
    <div class="fields island">
      <div class="form-group">
        <label for="parent-selector">
          {{ lang.get('category.form.parent.label') }}
        </label>
        <select
          id="parent-selector"
          class="form-control"
          @change="e => handleInput('parentId', toInt(e.target.value))"
        >
          <option>-</option>
          <option
            v-for="parent in parents"
            :key="'parent-' + parent.id"
            :value="parent.id"
            :selected="parent.id === category.parentId"
          >
            {{ parent.name }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>
          {{ lang.get('category.form.name.label') }}
        </label>
        <multilingual
          :supported-languages="supportedLanguages"
          :resource="category"
          property="name"
          @input="translated => handleTranslatedInput('name', translated)"
        />
      </div>
      <div class="form-group">
        <label>
          {{ lang.get('category.form.description.label') }}
          <help-icon :content="lang.get('category.form.description.help')" />
        </label>
        <multilingual
          mode="markdown"
          :supported-languages="supportedLanguages"
          :resource="category"
          property="description"
          @input="
            translated => handleTranslatedInput('description', translated, true)
          "
        />
      </div>
      <div class="form-group">
        <label>
          {{ lang.get('category.form.shortcode.label') }}
          <help-icon :content="lang.get('category.form.shortcode.help')" />
        </label>
        <multilingual
          mode="text"
          :supported-languages="supportedLanguages"
          :resource="category"
          property="shortcode"
          @input="
            translated =>
              handleTranslatedInput('shortcode', translated, false, false)
          "
        />
      </div>
      <div class="form-group">
        <div class="checkbox styled">
          <input
            id="active"
            name="active"
            type="checkbox"
            :checked="category.active"
            @change="e => handleInput('active', e.target.checked)"
          />
          <label for="active">
            {{ lang.get('category.form.active.label') }}
          </label>
        </div>
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import { mapGetters } from 'vuex';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import HelpIcon from '@/lib/components/Shared/HelpIcon';
import Multilingual from '@/lib/components/Translations/Multilingual';
import handleInputMixin from '../handle-input-mixin.js';
import handleTranslatedInputMixin from '../handle-translated-input-mixin.js';
import toIntMixin from '../to-int-mixin.js';

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection,
    HelpIcon,
    Multilingual
  },
  mixins: [handleInputMixin, handleTranslatedInputMixin, toIntMixin],
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('entryForm', ['categoriesIndex']),
    parents() {
      return this.categoriesIndex.filter(c => c.id !== this.category.id);
    }
  }
};
</script>
